import EventStatus from "./EventStatus";

import moment from "moment";

export default ({ event, onClickEvent }) => {
  //console.log("EVENT", event);

  return (
    <div
      className={`slot-event-card-simple slot-event-card-simple-big-text ${event.timeStart === -1 ? "slot-event-card-simple-fullday" : ""}`}
      style={
        event.timeStart === -1 ? { backgroundColor: event.calendarColor } : {}
      }
      onClick={(e) => {
        e.stopPropagation();
        onClickEvent(event);
      }}
    >
      <EventStatus status={event.status} />
      <span style={{}}>
        {event.timeStart !== -1 && (
          <span style={{ color: event.calendarColor }}>
            {moment(event.date, "YYYY-MM-DD").format("DD/MM/YYYY")}{" "}
            {moment(event.timeStart, "HH:mm:ss").format("HH:mm")} -{" "}
          </span>
        )}
        {event.subject}
        {event.agent !== "" && <span>{" - " + event.agent}</span>}
      </span>
    </div>
  );
};
